import SixTileCarousel from './SixTileCarousel';

export * from './types';
export default SixTileCarousel;
